import React, { useState, useEffect } from 'react'
import SidebarProposal from '../../../layouts/sidebarProposal/SidebarProposal'
import { startLoading, doneLoading } from '../../../utils/loading'
import ContentHeader from '../../../components/ContentHeader/ContentHeader'
import PanalLoadingTemplate from '../../../widgets/loadingTemplate/panalLoadingTemplate/PanalLoadingTemplate'
import ErrorWidget from '../../../widgets/errorWidget/ErrorWidget'
import { getExpensesCheckById } from '../../../redux/actions/accountingExpenses'
import { sessionGetItemObj } from '../../../utils/sessionHelpers'
import ExpenseCheckWidget from '../../../widgets/expenseRecordWidget/ExpenseCheckWidget'

export default function ExpenseCheck() {
  const [schema, setSchema] = useState()
  const [isLoading, setIsLoading] = useState(false)
  const [error, setError] = useState()

  const projectCode = sessionStorage.getItem('projectCode')
  const { periodNumber } = sessionGetItemObj('periodInfo')
  const { id, editMode } = sessionGetItemObj('checkData')

  useEffect(() => {
    handleGetSchema()
  }, [])

  const handleGetSchema = async () => {
    setIsLoading(true)
    startLoading()
    try {
      const response = await getExpensesCheckById(projectCode, periodNumber, id)

      if (response) {
        setSchema(response.model)
      }
    } catch (e) {
      console.log('error', e)
      if (e?.response?.data) {
        setError({
          statusCode: e.response.data.status,
          errorMessage: e.response.data.errors?.message,
        })
      } else {
        setError({})
      }
    }
    doneLoading()
    setIsLoading(false)
  }

  if (error) {
    return (
      <SidebarProposal isIncomeExpense>
        <ErrorWidget statusCode={error.statusCode} errorMessage={error.errorMessage} />
      </SidebarProposal>
    )
  }

  if (!schema || isLoading) {
    return (
      <SidebarProposal isIncomeExpense>
        <PanalLoadingTemplate />
      </SidebarProposal>
    )
  }

  return (
    <div>
      <SidebarProposal isIncomeExpense>
        <ContentHeader
          header={schema.header}
          subHeader={''}
          isNotCallApi
          isShowGoButton
          cleanSessions={['checkData']}
        />

        <ExpenseCheckWidget schema={schema} />
        <br />
      </SidebarProposal>
    </div>
  )
}
